
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { BanknoteIcon, CreditCard } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PaymentFormValues } from './types';
import BankAccountForm from './BankAccountForm';
import PaypalForm from './PaypalForm';

type PaymentMethodTabsProps = {
  form: UseFormReturn<PaymentFormValues>;
  activeTab: string;
  onTabChange: (value: string) => void;
};

const PaymentMethodTabs: React.FC<PaymentMethodTabsProps> = ({ 
  form, 
  activeTab, 
  onTabChange 
}) => {
  return (
    <Tabs 
      value={activeTab} 
      onValueChange={onTabChange}
      className="w-full"
    >
      <TabsList className="grid w-full grid-cols-2 p-1 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg">
        <TabsTrigger 
          value="bank" 
          className="flex items-center transition-all duration-200 data-[state=active]:bg-white data-[state=active]:text-primary-blue data-[state=active]:shadow-sm"
        >
          <BanknoteIcon className="mr-2 h-4 w-4" />
          Bank Account
        </TabsTrigger>
        <TabsTrigger 
          value="paypal" 
          className="flex items-center transition-all duration-200 data-[state=active]:bg-white data-[state=active]:text-primary-blue data-[state=active]:shadow-sm"
        >
          <CreditCard className="mr-2 h-4 w-4" />
          PayPal
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="bank" className="space-y-4 mt-6 animate-fade-in">
        <BankAccountForm form={form} />
      </TabsContent>
      
      <TabsContent value="paypal" className="space-y-4 mt-6 animate-fade-in">
        <PaypalForm form={form} />
      </TabsContent>
    </Tabs>
  );
};

export default PaymentMethodTabs;
